import React, { ReactNode } from "react";

interface SettingsRowProps {
  label: string;
  /**
   * Optional, and deliberately rare.
   *
   * Most labels say what they do, and a line under every one of them turned
   * the dialog into documentation. A description now means "this row is not
   * obvious": auto connect does not say that it is per browser, and a
   * destructive action has to name what it destroys.
   */
  description?: string;
  control: ReactNode;
  testId?: string;
}

export default function SettingsRow(props: SettingsRowProps) {
  const { label, description, control, testId } = props;

  return (
    <div
      className="flex items-center gap-[16px] px-[14px] py-[10px]"
      data-testid={testId}
    >
      <div className="flex flex-col gap-[1px] min-w-0 flex-1">
        <div className="text-[14px] font-medium text-creator-text">{label}</div>
        {description && (
          <div className="text-[11.5px] leading-[16px] text-creator-text-sub">
            {description}
          </div>
        )}
      </div>
      <div className="shrink-0">{control}</div>
    </div>
  );
}
